window.Help = (function () {
	var dom = {};
	var selectors = {
        scrollArea: '#m-page-content-scrollbar-scrollarea',
        pageNavigation: '#help-page__navigation-links',
        pageNavigationLinks: '.help-page__navigation-link',
        aboutContent: '#about-content',
        rulesSections: '.help-page__content-part[id]',
        rulesSectionsCom: '.rules-section',
	};
    var pageNavigationOffsets = [];
    var pageNavigationOffsetTop = 0;


	return {
        init: function () {
            dom.pageNavigation = $(selectors.pageNavigation);
            var hashBlock;
            dom.scrollArea = $(selectors.scrollArea);
            if (dom.scrollArea.length == 0) {
                dom.scrollArea = { position: function () { return { top: 0 } } };
            }

            pageNavigationOffsetTop = dom.pageNavigation.position().top - dom.scrollArea.position().top;

            this.createNavigationMenu();
            this.updateHeadingTopOffset();

            if(window.location.hash) {
                hashBlock = $(window.location.hash);
                if (hashBlock.length > 0) {
                    $(selectors.scrollArea).scrollTop(hashBlock.position().top - 70);
                }
            } else {
                this.setActiveNavigationItem(0);
            }

            this.bindUI();
		},
		bindUI: function () {
			var self = this;

            var scrollTimer;
            
            $(selectors.scrollArea).on('scroll.pageHelp', function() {
                var scrollTop = $(this).scrollTop();

                if (app.isIE()) {
                    self.toggleFixedPageNavigation(scrollTop);
                }

                if (scrollTimer) {
                    clearTimeout(scrollTimer);
                }

                scrollTimer = setTimeout(function () {
                    self.setActiveNavigationItem(scrollTop);
                }, 50);
            });
            
            $(window).on('resize.pageHelp', function() {
                self.updateHeadingTopOffset();
            });
		},
        unbindUI: function () {
            $(selectors.scrollArea).off('scroll.pageHelp');
            $(window).off('resize.pageHelp');
        },
        updateHeadingTopOffset: function() {
            var scrollAreaTopOffset = dom.scrollArea.position().top;

            $(selectors.pageNavigationLinks).each(function (index) {
                var id = $(this).attr('href');
                var heading = $(id);
                pageNavigationOffsets.push({
                    id: id,
                    offsetTop: index === 0 ? 0 : heading.position().top - scrollAreaTopOffset - 80
                })
            });
        },
        toggleFixedPageNavigation: function (scrollTop) {
            var delta = scrollTop - pageNavigationOffsetTop;

            dom.pageNavigation.css({
                transform: 'translateY(' + (delta > 0 ? delta : 0) + 'px)'
            });
        },
        setActiveNavigationItem: function (scrollTop) {
            let mobile = window.globalAppSettings.isMobileDevice;
            if (mobile) return;
            for (let i = 0; i < pageNavigationOffsets.length; ++i) {
                if (scrollTop >= pageNavigationOffsets[i].offsetTop && (i + 1 >= pageNavigationOffsets.length || scrollTop < pageNavigationOffsets[i + 1].offsetTop)) {
                    $(selectors.pageNavigationLinks).removeClass('m-active');
                    $(selectors.pageNavigationLinks).filter('[href="' + pageNavigationOffsets[i].id + '"]').addClass('m-active');

                    if (history.pushState && window.location.hash !== pageNavigationOffsets[i].id) {
                        history.pushState(null, null, pageNavigationOffsets[i].id);
                    }
                }
            }
        },
        createNavigationMenu: function () {
            $(selectors.rulesSections).each((index, section) => {
                const sectionId = section.id;
                const headingText = $(section).find('h2').text();
                const link = `<a href="#${sectionId}" class="help-page__navigation-link" data-mtm-trigger="d-i08-e11">${headingText}</a>`;
                dom.pageNavigation.append(link);
            });

            $(selectors.rulesSectionsCom).each((index, headingEl) => {
                const sectionNumber = index + 1;
                headingEl.id = "rules-section-" + sectionNumber;
                const link = `<a href="#${headingEl.id}" class="help-page__navigation-link">${sectionNumber}. ${headingEl.textContent}</a>`;
                dom.pageNavigation.append(link);
            });
        }
	}
}());

$(function () {

    if ($('#help-page').length > 0) {
        window.Help.init();
        if (globalAppSettings.isMobileDevice && UpButton) {
            UpButton.init();
            if ($('#contentEl').length > 0) {
                var point = $('.help-page__content').offset().top;
                $(window).scrollTop(point - 50);
            }
        }
    }

});